import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-remindered-orders',
  templateUrl: './remindered-orders.component.html',
  styleUrls: ['./remindered-orders.component.scss']
})
export class ReminderedOrdersComponent implements OnInit {

  requestType : string = 'order';
  hideActionsColumn : boolean = true;
  isReminder:boolean = true;
  title : string = 'التذكير بأوامر الصيانة غير المنفذة';
  
  constructor() { }

  ngOnInit() {
  }

}
